import { FC } from 'react';
import { Ancestor, AncestriesRelevanceIds, SkillTableItem } from './SkillsTable';
import { skillUrl } from '../../utils/removeSearchHighlight';

interface Props {
  skill: SkillTableItem;
}

export const SkillRowContent: FC<Props> = ({ skill }) => {
  return (
    <div className="flex flex-column px-4 skill-info-container border-round-lg pb-3">
      <div className="flex w-full">
        <div className="col-6">
          <p className="font-bold">Description:</p>
          <p dangerouslySetInnerHTML={{ __html: skill.summary }}></p>
        </div>
        <div className="col-6">
          <p className="font-bold">Challenge Criteria:</p>
          <p>{skill.assessmentInfo}</p>
        </div>
      </div>
      <div>
        <hr />
      </div>
      <p>
        These are the essential and helpful predecessors for the target skill. Completing these skills will increase
        student readiness for the target skill.
      </p>
      <div className="p-2 bg-white border-round-lg">
        <p className="font-medium">
          <i className="nc_icon-nc_support icon-sm"></i>
          <span className="ml-2 text-lg">Essential Skill(s)</span>
        </p>
        <hr className="bg-dark" />
        <div className="mt-2 p-2">
          {skill.skillAncestries
            .filter(sk => sk.skillRelevance.id === AncestriesRelevanceIds.ESSENTIAL)
            .map((ancestor, index) => (
              <AncestorRow key={`${ancestor.ancestorSkill.id}-${index}`} ancestor={ancestor} />
            ))}
        </div>
      </div>
      <div className="p-2 bg-white border-round-lg mt-3">
        <p className="font-medium">
          <i className="nc_icon-nc_support icon-sm"></i>
          <span className="ml-2 text-lg">Helpful Skill(s)</span>
        </p>
        <hr className="bg-dark" />
        <div className="mt-2 p-2">
          {skill.skillAncestries
            .filter(sk => sk.skillRelevance.id === AncestriesRelevanceIds.HELPFUL)
            .map((ancestor, index) => (
              <AncestorRow key={`${ancestor.ancestorSkill.id}-${index}`} ancestor={ancestor} />
            ))}
        </div>
      </div>
    </div>
  );
};

const AncestorRow: FC<{ ancestor: Ancestor }> = ({ ancestor }) => {
  const UrlSkill = skillUrl(ancestor.ancestorSkill.code);

  return (
    <a
      href={UrlSkill}
      className="text-primary tw-text-lg tw-font-bold border-bottom-2 surface-border py-2 cursor-pointer block"
      dangerouslySetInnerHTML={{ __html: `${ancestor.ancestorSkill.name} (${ancestor.ancestorSkill.code})` }}
    />
  );
};
